module.exports = __webpack_public_path__ + "img/oth3.7f84c18f.png";